import  {baseActions}  from "./base.actions";

export const patientActions = {
    add,
    edit,
    gets,
    get,
    delete: _delete
};

function add(obj,func=null) {
    
    return baseActions.add(obj,'patient',null,func)
}

function edit(obj,id,func=null) {
    return baseActions.edit(obj,'patient',id,null,func);
}

function gets( page, perPage, sortField, sortOrder,filter) {
    return baseActions.gets('patient', page, perPage, sortField, sortOrder,filter);
}

function get(id)
{
    return baseActions.get('patient',id);
}

function _delete(id,func=null)
{
    return baseActions.delete(id,'patient',func);
}